import React from 'react'
import styles from './EmailInput.module.css';

interface EmailInputProps {
  label?: string;
  value?: string | null;
  placeHolder?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string | null;
  verifyEmail?: boolean;
  onVerifyEmail?: () => void;
  className?: string
}

const EmailInput = ({ label, onChange, error, placeHolder, value, verifyEmail, onVerifyEmail, className = "" }: EmailInputProps) => {

  return (
    <div className={styles.inputWrapper}>
      {label && <label>{label}</label>}
      <div>
        <div className={styles.fieldWrapper}>
          <input
            inputMode='email'
            className={`${styles.input} ${verifyEmail ? styles.withText : ''} ${className}`}
            type='email'
            value={value || ""}
            placeholder={placeHolder || 'Enter Email Id'}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              onChange && onChange(event);
            }}
          />
          {(verifyEmail && !error && value && value?.length > 0) && <button onClick={onVerifyEmail} type='button' disabled={error ? true : (value === null || value && value.trim() === '') ? true : false} className={styles.verifyEmail}>Verfiy Email</button>}
        </div>
        {error && <div className={styles.errorText}>{error}</div>}
      </div>
    </div >
  )
}

export default EmailInput
